'use client';
import { ProductCardsProps } from '../link-list-icons/types';
import { LinkListIcons } from '../link-list-icons/link-list-icons';

export const ProductCards = (props: ProductCardsProps) => (
  <LinkListIcons {...props} />
);
